<template>
  <div v-if="Array.isArray(data) && data.length">
    <component
      :is="resolveSectionComponent(section.__typename as SectionComponents)"
      v-for="(section, index) in data"
      :key="section.__typename"
      :index="index"
      :data="section"
    />
  </div>
</template>

<script setup lang="ts">
import type { SectionComponents } from '~/types/components'
import type { ProgramProductModelBlocksField } from '~/types/generated'
defineProps({
  data: {
    type: Array as PropType<ProgramProductModelBlocksField[]>,
    default: () => {}
  }
})
const { resolveSectionComponent } = useResolveComponent()
</script>
